package com.platforma.chat_domain.model

import com.platforma.chat_domain.MessageStatus

data class TableMessageDomain(
    val text: String,
    val status: MessageStatus,
    val senderId: Long
)
